function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

import HyperFormula from "hyperformula";
import _ from "lodash";

function toColumnName(num) {
  for (var ret = "", a = 1, b = 26; (num -= a) >= 0; a = b, b *= 26) {
    ret = String.fromCharCode(parseInt(num % b / a) + 65) + ret;
  }

  return ret;
}

var HyperFormulaBuilder = /*#__PURE__*/function () {
  function HyperFormulaBuilder() {
    this.hyperformula = HyperFormula.buildEmpty({
      precisionRounding: 10,
      licenseKey: "agpl-v3"
    });
    this.mainSheetName = this.hyperformula.addSheet("main");
  }

  var _proto = HyperFormulaBuilder.prototype;

  _proto.withHeaders = function withHeaders(headers) {
    var headerKeys = _.map(headers, function (header) {
      return header.header;
    });

    this.headers = headers;
    this.hyperformula.setCellContents({
      row: 0,
      col: 0,
      sheet: 0
    }, [headerKeys]);
  };

  _proto.getConvertedValues = function getConvertedValues() {
    return this.hyperformula.getSheetValues(this.sheetId);
  };

  _proto.getComputedValue = function getComputedValue(headerName, rowIndex) {
    var indexOfHeader = _.findIndex(this.headers, function (header) {
      return header.header === headerName;
    });

    return this.hyperformula.getCellValue({
      col: indexOfHeader,
      row: rowIndex + 0,
      sheet: this.sheetId
    });
  };

  _proto.getValue = function getValue(headerName, rowIndex) {
    var indexOfHeader = _.findIndex(this.headers, function (header) {
      return header.header === headerName;
    });

    return this.hyperformula.getCellFormula({
      col: indexOfHeader,
      row: rowIndex + 0,
      sheet: this.sheetId
    });
  };

  _proto.getRow = function getRow(obj, index) {
    var values = _.map(this.headers, function (header) {
      if (header.readOnly) {
        return _.replace("=" + header.formula, new RegExp("\\[i\\]", "g"), index);
      }

      return _.get(obj, header.header);
    });

    return values;
  };

  _proto.getRows = function getRows(dataObjects) {
    var _this = this;

    var rows = _.map(dataObjects, function (obj, index) {
      return _this.getRow(obj, index + 1);
    });

    return rows;
  };

  _proto.withDataObjects = function withDataObjects(dataObjects) {
    this.rows = this.getRows(dataObjects);
    this.hyperformula.setCellContents({
      row: 0,
      col: 0,
      sheet: 0
    }, this.rows);
    return this;
  };

  _createClass(HyperFormulaBuilder, [{
    key: "sheetId",
    get: function get() {
      return this.hyperformula.getSheetId(this.mainSheetName);
    }
  }]);

  return HyperFormulaBuilder;
}();

export default HyperFormulaBuilder;